import React, { Component } from "react";
import moment from "moment";
import { Spin } from "antd";
import Bridge from "../../utils/Bridge";


export default class ActiGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      loading: false,
    };
  }
  componentDidMount() {
    this.get_actigraph_list()
  }
  get_actigraph_list=()=>{
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    this.setState({loading:true})
    Bridge.personal_data_viewer
    .get_actigraph_list(params)
    .then((res) => {
      if (res.status == 1) {
        this.setState({
          records: res.data,
          loading:false
        })
      }else{
        this.setState({loading:false})
      }
    }).catch((err)=>{
      this.setState({loading:false})
    })
  }
  render() {
    return (
      <div className="als_frs_sessions">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 px-0">
              <Spin spinning={this.state.loading}>
                <h5 className="pt-2 pb-3">Your Wear Stats: Day Breakdown</h5>
                <table>
                  <tr>
                    <th>Day of Device Wear </th>
                    <th>Total Wear Time</th>
                    <th>Estimated Steps Taken</th>
                    <th>Estimated Calorie Expenditure</th>
                  </tr>
                  {this.state.records &&
                    this.state.records.map((item, index) => {
                      const hours = Math.floor(item.total_wear_time / 60); 
                      const remainingMinutes = item.total_wear_time % 60;
                      let time=hours + " hrs " + remainingMinutes + " min";
                      return (
                        <tr key={index}>
                          <td style={{ width: 300 }}>
                            {item.day_of_device_wear_breakdown? moment(item.day_of_device_wear_breakdown).format("MM/DD/YYYY")  : "---"}
                          </td>
                          <td>{item.total_wear_time!=0 ? time : "0 hrs 0 min"}</td>
                          <td>{item.estimated_steps_taken ? item.estimated_steps_taken+' steps' : "---"}</td>
                          <td>{item.expected_calorie_expenditure ? parseFloat(item.expected_calorie_expenditure).toFixed(0) +" calories" : "---"}</td>
                        </tr>
                      );
                    })}
                    {this.state.records.length==0 && (
                      <tr>
                        <td style={{ width: 300 }} colSpan={4}>Not available..</td>
                      </tr>
                    )}
                </table>
                <br />
                <h5 className="pt-2 pb-3">
                  Your Wear Stats: Activity Peak and Intensity Levels
                </h5>
                <table>
                  <tr>
                    <th>Day of Device Wear </th>
                    <th>Minutes of Moderate to Vigorous Physical Activity</th>
                    <th>% of Moderate to Vigorous Physical Activity</th>
                    <th>Total Wear Minutes</th>
                  </tr>
                  {this.state.records &&
                    this.state.records.map((item, index) => {

                      const hours = Math.floor(item.total_wear_time / 60); 
                      const remainingMinutes = item.total_wear_time % 60;

                      let time=hours + " hrs " + remainingMinutes + " min";

                      let moderate_minutes=Number(item.moderate_to_vigorous_physical_activity_in_seconds) / 60;

                     
                      let percentage = (moderate_minutes / item.total_wear_time) * 100;

                      return (
                        <tr key={index}>
                          <td style={{ width: 300 }}>
                            {item.day_of_device_wear_activity? moment(item.day_of_device_wear_activity).format("MM/DD/YYYY")  : "---"}
                          </td>
                          <td>{item.moderate_to_vigorous_physical_activity_in_seconds ? moderate_minutes+' minutes' : "---"}</td>
                          <td>{percentage ? percentage.toFixed(2) :0} %</td>
                          <td>{item.total_wear_time!=0 ? time : "0 hrs 0 min"}</td>
                        </tr>
                      );
                    })}
                    {this.state.records.length==0 && (
                      <tr>
                        <td style={{ width: 300 }} colSpan={4}>Not available..</td>
                      </tr>
                    )}
                  {/* <tr>
                    <td style={{ width: 300 }}>10/20/2024</td>
                    <td>100 minutes </td>
                    <td>%</td>
                    <td>100 minutes </td>
                  </tr> */}
                </table>
              </Spin>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
